import {
  Component
} from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController
} from "ionic-angular";
import {
  APIServiceProvider
} from "./../../../common/services/api.service";
import {
  CustomerModalPage
} from "../../../modals/customer/customer.modal";
import {
  OrderdetailsModalPage
} from "../../../modals/orderdetails/orderdetails.modal";
import {
  NotifyService
} from "../../../services/notify.service";
import {
  OrderDeliveredModalPage
} from "../../../modals/orderdelivered/orderdelivered.modal";

import {
  HelperServiceProvider
} from "./../../../common/services/helper.service";
import { OrderCancelPage } from "../../../modals/order-cancel/order-cancel";
import { PaymentInfoPage } from "../../../modals/payment-info/payment-info";

@Component({
    selector: "page-cashnotsubmitted",
    templateUrl: "cashnotsubmitted.html"
})
export class CashnotsubmittedPage {
    public ordersData: any = [];
  public ordersApiResponse: any;
  private apiUrl: any = "orders/all";
  public settlementPendingTotal: any = 0;
  public postParams: any = {
    order_status: 4,
    payment_order_key: "new",
    payment_order_status: "Others",
    dispatched_to: localStorage.getItem("manager_user_id"),
    paginate: 'yes'
  };

  public user_id: any = localStorage.getItem("user-id");
  public manager_user_id: any = localStorage.getItem("manager_user_id");

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public apiService: APIServiceProvider,
    public helperService: HelperServiceProvider,
    public modalController: ModalController,
    private notifyService: NotifyService
  ) {
    this.notifyService.orderReceived.subscribe(() => {
      this.getOrdersReceived();
    });

    this.notifyService.orderCancelled.subscribe(() => {
      this.getOrdersReceived();
    });

    this.notifyService.orderDelivered.subscribe(() => {
      this.getOrdersReceived();
    });
  }
  ionViewWillEnter(){
    this.getOrdersReceived();
  }
  // ionViewDidLoad() {
  //   console.log('sdsd');
  //   this.getOrdersReceived();
  // }

  doInfiniteScroll(infiniteScroll) {
    if (!this.ordersApiResponse.next_page_url ||
      this.ordersApiResponse.next_page_url === "" ||
      this.ordersApiResponse.next_page_url === null ||
      this.ordersApiResponse.next_page_url === "null"
    ) {
      infiniteScroll.complete();
      return;
    }
    this.apiService
      .post(this.apiUrl, this.postParams, this.ordersApiResponse.next_page_url)
      .subscribe(data => {
        this.ordersApiResponse = data["data"];
         this.settlementPendingTotal = this.settlementPendingTotal + data['total_pending_amount']; 
        this.ordersData = this.ordersData.concat(data["data"]["data"]);
        infiniteScroll.complete();
      });
  }

  getOrdersReceived(refresh ? ) {
    this.apiService.post(this.apiUrl, this.postParams).subscribe(data => {
    this.settlementPendingTotal = data["total_pending_amount"];
      this.ordersApiResponse = data["data"];
      this.ordersData = data["data"]["data"];
      console.log(this.ordersData);
      if (refresh) {
        refresh.complete();
      }
    });
  }

  showCustomerModel(order_id) {
    let modalObject = this.modalController.create(CustomerModalPage, {
      order_id: order_id
    });

    modalObject.present();
  }

  doRefresh(refresh) {
    this.getOrdersReceived(refresh);
  } 

  showOrderDetailsModal(order) {
    console.log(order)
    this.getOrderDetailsPayment(order?.order_payment_detail?.opportunity_id).then(data => {
      let modalObject = this.modalController.create(PaymentInfoPage, {
        orderDetails: order
      });

      modalObject.present();
    });
  }
  getOrderDetailsPayment(order_id) {
    return new Promise((resolve, reject) => {
      const params = {
        order_id
      };
      this.apiService
        .get("order/finance/get-payment-history/"+order_id)
        .subscribe(result => {
          resolve(result);
        });
    });
  }
  getOrderDetails(order_id) {
    return new Promise((resolve, reject) => {
      const params = {
        order_id
      };
      this.apiService
        .post("orders/get-order-details", params)
        .subscribe(result => {
          resolve(result);
        });
    });
  }

  orderStatus(data) {
    let modalObject = this.modalController.create(OrderDeliveredModalPage, {
      order: data,
      request_order_status: 5
    });
    modalObject.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders/cashnotsubmitted/cashnotsubmitted.ts